import { createContext, useContext, type ReactNode } from "react";
import { ConfigProvider, type ThemeConfig } from "./ui/antd";
import { adminIceTheme } from "./admin-appearance";
import "./enterprise-appearance.css";

const EnterpriseVisualContext = createContext(false);
export const useEnterpriseVisual = () => useContext(EnterpriseVisualContext);

const enterpriseTheme: ThemeConfig = {
  components: {
    Button: {
      colorPrimary: adminIceTheme.token!.colorPrimary,
      colorPrimaryHover: adminIceTheme.token!.colorPrimaryHover,
      colorPrimaryActive: adminIceTheme.token!.colorPrimaryActive,
      primaryColor: "#ffffff",
    },
  },
};

/** Scope the approved enterprise workspace and portal overlays to tenant admin pages. */
export default function EnterpriseAppearance({ enabled, page, children }: { enabled: boolean; page: string; children: ReactNode }) {
  if (!enabled) return children;
  return <EnterpriseVisualContext.Provider value>
    <ConfigProvider theme={enterpriseTheme}
      modal={{ className: "enterprise-overlay" }}
      drawer={{ className: "enterprise-overlay" }}
      select={{ classNames: { popup: { root: "enterprise-popup" } } }}
      dropdown={{ className: "enterprise-popup" }}
      timePicker={{ classNames: { popup: { root: "enterprise-popup" } } }}
      popover={{ classNames: { root: "enterprise-popup" } }}
      popconfirm={{ classNames: { root: "enterprise-popup" } }}>
      <div className={`enterprise-surface page-${page}`}>{children}</div>
    </ConfigProvider>
  </EnterpriseVisualContext.Provider>;
}
